export default __webpack_public_path__ + "static/media/avatar-s-5.301316d5.jpg";